import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import DeliveryOptionIcon from '../_utils/_delivery-options/delivery-option-icon';
import deliveryOptionType from './types/delivery-option-type';

const PreviewableDeliveryOptions = ({
  deliveryOptions,
  deliveryOptionKeys,
}) => {
  return (
    <div className="delivery-options-list">
      {(deliveryOptions || []).map((option) => {
        const available = (deliveryOptionKeys || []).includes(option.key);
        const unavailable = !available;

        return (
          <div
            key={option.key}
            className={classNames('delivery-option', {
              available,
              unavailable,
            })}
            data-test-id="delivery-option">
            <DeliveryOptionIcon option={option} />
          </div>
        );
      })}
    </div>
  );
};

PreviewableDeliveryOptions.propTypes = {
  deliveryOptions: PropTypes.arrayOf(deliveryOptionType),
  deliveryOptionKeys: PropTypes.arrayOf(PropTypes.number),
};

PreviewableDeliveryOptions.defaultProps = {
  deliveryOptions: null,
  deliveryOptionKeys: null,
};

export default PreviewableDeliveryOptions;
